import {Key} from 'react';
import {Action} from 'redux';
import {v4 as uuid} from 'uuid';

import {isAction} from '../utils';
import {Notification} from './state';

// Action Types

export const CREATE_SNACKBAR = 'SNACKBAR.CREATE';
export const CLOSE_SNACKBAR = 'SNACKBAR.CLOSE';
export const CLOSE_ALL_SNACKBARS = 'SNACKBAR.CLOSE_ALL';
export const DISPLAY_SNACKBAR = 'SNACKBAR.DISPLAY';
export const REMOVE_SNACKBAR = 'SNACKBAR.REMOVE';

// Action Interfaces

export interface CreateSnackbar extends Action {
  key: Key;
  notification: Notification;
  type: typeof CREATE_SNACKBAR;
}
export interface CloseSnackbar extends Action {
  key: Key;
  type: typeof CLOSE_SNACKBAR;
}
export interface CloseAllSnackbars extends Action {
  type: typeof CLOSE_ALL_SNACKBARS;
}
export interface DisplaySnackbar extends Action {
  key: Key;
  type: typeof DISPLAY_SNACKBAR;
}
export interface RemoveSnackbar extends Action {
  key: Key;
  type: typeof REMOVE_SNACKBAR;
}

// Action Creators

export function createSnackbar(notification: Notification): CreateSnackbar {
  const key = notification.options && notification.options.key;

  return {
    key: key || uuid(),
    notification,
    type: CREATE_SNACKBAR
  };
}
export const isCreateSnackbar = isAction<CreateSnackbar>(CREATE_SNACKBAR);

export function displaySnackbar(key: Key): DisplaySnackbar {
  return {
    key,
    type: DISPLAY_SNACKBAR
  };
}
export const isDisplaySnackbar = isAction<DisplaySnackbar>(DISPLAY_SNACKBAR);

export function closeSnackbar(key: Key): CloseSnackbar {
  return {
    key,
    type: CLOSE_SNACKBAR
  };
}
export const isCloseSnackbar = isAction<CloseSnackbar>(CLOSE_SNACKBAR);

export function closeAllSnackbars(): CloseAllSnackbars {
  return {
    type: CLOSE_ALL_SNACKBARS
  };
}
export const isCloseAllSnackbars = isAction<CloseAllSnackbars>(CLOSE_ALL_SNACKBARS);

export const removeSnackbar = (key: Key) => ({
  key,
  type: REMOVE_SNACKBAR
});
export const isRemoveSnackbar = isAction<RemoveSnackbar>(REMOVE_SNACKBAR);
